import { SGWS_NAME } from '~/constants/customers'

import type { EntityDomain } from '~/src/components/RyderShare/shared/terminology/types'

export const isSgwsCustomer = (customerName?: string | null): boolean =>
  customerName === SGWS_NAME

export const getEntityDomain = (customerName?: string | null): EntityDomain =>
  isSgwsCustomer(customerName) ? 'purchaseOrder' : 'shipment'

export const splitTranslationKey = (
  key: string,
  defaultNamespace: string | ReadonlyArray<string>
) => {
  if (key.includes(':')) {
    const [namespace, keyPath] = key.split(':')

    return { namespace, keyPath }
  }

  const namespace = Array.isArray(defaultNamespace)
    ? defaultNamespace[0]
    : defaultNamespace

  return { namespace, keyPath: key }
}
